import React from 'react';
import { usePreferencesStore } from '../../store/preferencesStore';
import { isTauri } from '../../utils/tauri';
import { Toggle, Segmented, Row, Section, NumberInputWithUnit } from '../settingsPrimitives';

export const EditorTab = ({ t }) => {
  const editorFontFamily   = usePreferencesStore((s) => s.editorFontFamily);
  const editorFontSize     = usePreferencesStore((s) => s.editorFontSize);
  const editorTabSize      = usePreferencesStore((s) => s.editorTabSize);
  const wordWrap           = usePreferencesStore((s) => s.wordWrap);
  const stickyScroll       = usePreferencesStore((s) => s.stickyScroll);
  const defaultResponseView = usePreferencesStore((s) => s.defaultResponseView);
  const responseSizeLimitMb = usePreferencesStore((s) => s.responseSizeLimitMb);
  const update             = usePreferencesStore((s) => s.updatePreference);

  const fontFamilyOptions = [
    'JetBrains Mono', 'Fira Code', 'Cascadia Code', 'Menlo', 'Consolas', 'monospace',
  ];

  return (
    <>
      <Section title={t('settings.codeEditor')}>
        <Row label={t('settings.editorFontFamily')}>
          <select
            value={editorFontFamily}
            onChange={(e) => update('editorFontFamily', e.target.value)}
            className="settings-select-native"
          >
            {fontFamilyOptions.map((f) => (
              <option key={f} value={f}>{f}</option>
            ))}
          </select>
        </Row>
        <Row label={t('settings.editorFontSize')}>
          <NumberInputWithUnit
            value={editorFontSize}
            onChange={(v) => update('editorFontSize', v)}
            min={10}
            max={24}
            unit="px"
            width={56}
          />
        </Row>
        <Row label={t('settings.editorTabSize')}>
          <Segmented
            value={editorTabSize}
            onChange={(v) => update('editorTabSize', v)}
            options={[
              { id: 2, label: '2' },
              { id: 4, label: '4' },
              { id: 8, label: '8' },
            ]}
          />
        </Row>
        <Row label={t('settings.wordWrap')} desc={t('settings.wordWrapDesc')}>
          <Toggle value={wordWrap} onChange={(v) => update('wordWrap', v)} />
        </Row>
        <Row label={t('settings.stickyScroll')} desc={t('settings.stickyScrollDesc')}>
          <Toggle value={stickyScroll} onChange={(v) => update('stickyScroll', v)} />
        </Row>
      </Section>

      <Section title={t('settings.responseViewer')}>
        <Row label={t('settings.defaultResponseView')}>
          <Segmented
            value={defaultResponseView}
            onChange={(v) => update('defaultResponseView', v)}
            options={[
              { id: 'pretty',  label: t('settings.viewPretty') },
              { id: 'raw',     label: t('settings.viewRaw') },
              { id: 'preview', label: t('settings.viewPreview') },
            ]}
          />
        </Row>
        <Row
          label={t('settings.maxResponseSize')}
          desc={isTauri() ? t('settings.maxResponseSizeDesc') : t('settings.requestsDesktopOnly')}
        >
          <NumberInputWithUnit
            value={responseSizeLimitMb}
            onChange={(v) => update('responseSizeLimitMb', v)}
            min={0}
            max={500}
            unit="MB"
            width={56}
            disabled={!isTauri()}
          />
        </Row>
      </Section>
    </>
  );
};
